import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

import getLastSchoolYear from "@/directory/utils/getLastSchoolYear/getLastSchoolYear";

dayjs.extend(isBetween);

const DATE_FORMAT = "YYYY-MM-DD";

// Compute these values on every call rather than on module load.
export const getToday = () => dayjs().endOf("day").format(DATE_FORMAT);

export const getStartOfDaysAgo = (days: number) =>
  dayjs().subtract(days, "days").format(DATE_FORMAT);

export const getEndOfCurrentMonth = () =>
  dayjs().endOf("month").format(DATE_FORMAT);

export const getStartOfLastCalendarMonths = (count: number) =>
  dayjs()
    .startOf("month")
    .subtract(count - 1, "month")
    .format(DATE_FORMAT);

export const getStartOfCurrentJuly = () =>
  dayjs().month(6).startOf("month").format(DATE_FORMAT);

export const getStartOfLastJuly = () =>
  dayjs().month(6).startOf("month").subtract(1, "year").format(DATE_FORMAT);

export const isInclusiveBetweenJan1AndJun30 = () =>
  dayjs().isBetween(
    dayjs().month(0).date(1),
    dayjs().month(5).date(30),
    "day",
    "[]",
  );

export const getLastYearDateRange = () => {
  const { startDate, endDate } = getLastSchoolYear();
  return {
    start: dayjs(startDate).format(DATE_FORMAT),
    end: dayjs(endDate).format(DATE_FORMAT),
  };
};
